// Tiny stateless SVG atoms reused across sections.

// Terminal-style chevron pair — replaces the soft round arrow with `>>`.
export const Arrow = () => (
  <span className="btn-arrow" aria-hidden="true">&gt;&gt;</span>
);

export const Squiggle = () => (
  <svg className="squiggle" viewBox="0 0 110 14" preserveAspectRatio="none">
    <path d="M2 8 Q 14 2, 28 8 T 56 8 T 84 8 T 108 8" />
  </svg>
);

export const PlayDot = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
    <path d="M2 1.5v7l6-3.5z" />
  </svg>
);
